import React from "react";
import { Svg, SVG_ICONS } from "../../../../../components/__common/Svg/Svg";
import { Typography } from "../../../../../components/__common/Typography/Typography";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { LayoutState } from "../../../../../store/reducers/layout-reducer";
import { useTranslation } from "react-i18next";

export const ServiceErrorDisplay = () => {
    const appLayoutState = useSelector<ApplicationState, LayoutState>(
        (state) => state.layout
    );
    const { isDarkMode } =  appLayoutState;
    const { t } = useTranslation();
    return (
        <div className="manage-apps__service-error-container">
            <Svg
                className="error-icon"
                icon={isDarkMode ? SVG_ICONS.SERVICE_ERROR_DISPLAY_DARK : SVG_ICONS.SERVICE_ERROR_DISPLAY}
                width={320}
                height={320}
            />
            <Typography variant="body1" className="error-message">
                {t("PRIVACY_ERR_502_MSG_EXP")}
            </Typography>
        </div>
    );
}